import React from "react";
import styles from "./Features.module.scss";
import TimeTrackingSVG from "components/SVGComponents/TimeTrackingSVG";
import ProjectsSVG from "components/SVGComponents/ProjectsSVG";
import ResourcePlanningSVG from "components/SVGComponents/ResourcePlanningSVG";

const features = [
  {
    title: "Create",
    description:
      "Find and contribute to projects by businesses and creative individuals",
    icon: <TimeTrackingSVG />,
  },
  {
    title: "Connect",
    description:
      "Network with creative professionals and contribute to the creative community",
    icon: <ProjectsSVG />,
  },
  {
    title: "Collaborate",
    description: "Discuss, ideate and create with other like-minded creatives",
    icon: <ResourcePlanningSVG />,
  },
];

const Features = () => {
  return (
    <section className={styles.features}>
      <h2 className={styles.title}>Our Core Features</h2>
      <p className={styles.subTitle}>Explore more about Qreativs</p>
      <div className={styles.featuresCards}>
        {features.map((feature) => (
          <div key={feature.title} className={styles.featureCard}>
            {feature.icon}
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
